import axios from 'axios';

const utilsService = {
    
	buscarPorCep:(cep)=>{
        const viacep = axios.create({
            baseURL: 'https://viacep.com.br/ws/',
        })
		return viacep.get(cep+'/json');
	},

    
    fecharAtividade: () =>{
        if(window.ReactNativeWebView){
            window.ReactNativeWebView.postMessage('close');
        }
        if(window.AndroidInterface){
            window.AndroidInterface?.closeWebView();
        }
    }


};

export default utilsService;